module.exports = "<h2>{{t('portDetails.nativePortDetails')|e}}</h2>\n<div class=\"rg-native-ports-list\"></div>\n";
